export interface DailyScoreRecord {
  dailyScoreDay: number;
  dailyScorePoints: number;
  dailyScoreGoal: number;
}

export interface ChartTicks {
  ticksWeekDay: number[];
  ticksMonths: number[];
  ticksWeekBegin: number[];
  ticksMonthBegin: number[];
}

export interface ChartData {
  allDailyGoalsChartArray: number[];
  allDailyScorePointsChartArray: number[];
  allDailyScoreDaysArray: number[];
  averageValueChartArray100: number[] | null;
  averageValueChartArray30: number[] | null;
  averageValueChartArray7: number[] | null;
  maxXScaleValue: number;
  dateLabels: string[];
  emptyLabels: string[];
  chartTicks: ChartTicks;
}

export interface AveragePointObj {
  active: boolean;
  value: number | null;
  willBeActiveInDaysCount: number | null;
}

export interface Stats {
  averageDailyScore100: AveragePointObj;
  averageDailyScore30: AveragePointObj;
  averageDailyScore7: AveragePointObj;
  chartDataLength: number;
  chartDataArrays: ChartData;
}
